import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField } from 'components/shared';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import FormSubSection from '../../FormSubSection';
import { GridCompact12 } from 'components/shared/Grid/Grid.components';

const HoursBalanceSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.hours_balance'
  });

  return (
    <MultiStepForm.Section title={t('title')}>
      <FormSubSection title={t('deviation')}>
        <GridCompact12>
          <ControlledTextField
            control={control}
            label={t('employed')}
            variant="outlined"
            type="number"
            name="finEBalHrsPrc"
          />
        </GridCompact12>
        <GridCompact12>
          <ControlledTextField
            control={control}
            label={t('leave')}
            variant="outlined"
            type="number"
            name="finEBalLvPrc"
          />
        </GridCompact12>
      </FormSubSection>
    </MultiStepForm.Section>
  );
};

export default HoursBalanceSection;
